<template>
    <div class="stars"><svg-icon class="star" v-for="item in 5" :key="item" icon-class="star" :class="[{'active': item <= number}]"></svg-icon></div>
</template>

<script>
import svgIcon from "../svgIcon.vue";

export default {
    name: "stars",
    components: { svgIcon },
    props: {
        num: Number | String
    },
    computed: {
        number() {
            return this.num || 0
        }
    }
}
</script>

<style lang="scss" scoped>
.stars {
    .star {
        width: 16px;
        height: 16px;
        color: #DADDE2;

        &.active {
            color: #FDBE2C;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/stars.vue